import React, { useEffect } from 'react';
import { EventData, STATUS, EVENTS, Joyride } from 'react-joyride';
import { useTourStore } from '../stores/tourStore';
import { tourSteps } from '../config/tourSteps';

export const ProductTour: React.FC = () => {
  const { run, stepIndex, hasCompletedTour, setStepIndex, completeTour, startTour } = useTourStore();

  // Auto-start for first-time users
  useEffect(() => {
    if (!hasCompletedTour && !run) {
      // Small delay to ensure elements are rendered
      const timer = setTimeout(() => {
        startTour();
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [hasCompletedTour, run, startTour]);

  const handleJoyrideCallback = (data: EventData) => {
    const { status, type, index } = data;
    const finishedStatuses: string[] = [STATUS.FINISHED, STATUS.SKIPPED];

    if (finishedStatuses.includes(status)) {
      completeTour();
    } else if (type === EVENTS.STEP_AFTER || type === EVENTS.TARGET_NOT_FOUND) {
      // Update state to advance the tour
      setStepIndex(index + (data.action === 'prev' ? -1 : 1));
    }
  };

  return (
    <Joyride
      onEvent={handleJoyrideCallback}
      continuous
      run={run}
      scrollToFirstStep
      stepIndex={stepIndex}
      steps={tourSteps}
      options={{
        arrowColor: '#1e293b', // slate-800
        backgroundColor: '#1e293b', // slate-800
        overlayColor: 'rgba(0, 0, 0, 0.7)',
        primaryColor: '#06b6d4', // cyan-500
        textColor: '#f8fafc', // slate-50
        width: 400,
        zIndex: 1000,
        showProgress: true,
        buttons: ['back', 'skip', 'primary'],
      }}
      styles={{
        tooltipContainer: {
          textAlign: 'left',
        },
        buttonPrimary: {
          backgroundColor: '#06b6d4', // cyan-500
          borderRadius: '0.375rem', // rounded-md
          color: '#ffffff',
        },
        buttonBack: {
          color: '#94a3b8', // slate-400
          marginRight: '1rem',
        },
        buttonSkip: {
          color: '#94a3b8', // slate-400
        },
        tooltipTitle: {
          fontWeight: 600,
          fontSize: '1.125rem', // text-lg
          marginBottom: '0.5rem',
          color: '#f8fafc', // slate-50
        },
        tooltipContent: {
          fontSize: '0.875rem', // text-sm
          color: '#cbd5e1', // slate-300
          lineHeight: 1.5,
        },
      }}
    />
  );
};
